// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3b2xw","list":"BalanceDue_list__3IEvy","listRow":"BalanceDue_listRow__3d-xb","total":"BalanceDue_total__17eNZ"};